import ComparesVersions from './ComparesVersions'
import RequiresIntegration from './RequiresIntegration'

export default {
  mixins: [
    ComparesVersions,
    RequiresIntegration,
  ],

  data: () => ({
    printing: false,
  }),

  methods: {
    initPrinter () {
      if (! this.multiPrinter) {
        AndroidPrinter.init()
        return
      }
      AndroidPrinter.init(JSON.stringify({
        test: !! this.integration?.test,
        config: this.integration?.config ?? {},
      }))
    },
  },
}
